var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE1\x84\x80\xE1\x85\xB3\xE1\x86\xB7\xE1\x84\x8B\xE1\x85\xB2\xE1\x86\xBC\xE1\x84\x8B\xE1\x85\xA1\xE1\x84\x8B\xE1\x85\xB5\xE1\x84\x8F\xE1\x85\xA9\xE1\x86\xAB_SVG_\xE1\x84\x82\xE1\x85\xA9\xE1\x86\xBC\xE1\x84\x92\xE1\x85\xA7\xE1\x86\xB8 1",
    clipPath: "url(#clip0_1736_9925)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.5 24C19.1274 24 24.5 18.6274 24.5 12C24.5 5.37258 19.1274 0 12.5 0C5.87258 0 0.5 5.37258 0.5 12C0.5 18.6274 5.87258 24 12.5 24Z",
    fill: "#005BAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M14.8658 6L12.4998 7.18756L10.1338 6L12.4998 10.498L14.8658 6Z",
    fill: "#FABE00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.6936 9.47604L15.6582 9.44382L17.3447 8.73537V6.35938L14.4113 7.61026C14.4113 7.61026 12.8242 10.6198 12.7873 10.6905C13.4123 10.764 13.9855 11.0735 14.3897 11.5557C14.7939 12.0379 14.9986 12.6564 14.9618 13.2845C14.925 13.9127 14.6495 14.503 14.1918 14.9348C13.734 15.3665 13.1286 15.6069 12.4993 15.6069C11.8701 15.6069 11.2647 15.3665 10.8069 14.9348C10.3491 14.503 10.0737 13.9127 10.0369 13.2845C10.0001 12.6564 10.2047 12.0379 10.609 11.5557C11.0132 11.0735 11.5864 10.764 12.2113 10.6905C12.1758 10.6214 10.5891 7.61026 10.5891 7.61026L7.66089 6.35938V8.73537L9.34844 9.44537L9.312 9.47649C7.28978 11.2394 7.07889 14.308 8.84178 16.3307C10.6047 18.3534 13.6736 18.5638 15.696 16.8009C17.7184 15.038 17.9291 11.9694 16.1669 9.94671C16.0211 9.77937 15.864 9.62226 15.6967 9.47649L15.6936 9.47604Z",
    fill: "#FABE00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1736_9925"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh);
export default __webpack_public_path__ + "static/media/nh.5067913d10f12d9bd39e4e0ffc1177b6.svg";
export { ForwardRef as ReactComponent };